import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import HttpClient from "../../utils/HttpClient";
import PasswordRuleTemplate from "./PasswordRuleTemplate";

const ChangePassword = () => {
    const [formData, setFormData] = useState({
        currentPassword: "",
        password: "",
        confirmPassword: "",
    });
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const { UserProfileID } = useSelector((state) => state.app);
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [validation, setValidation] = useState({
        lowercase: false,
        uppercase: false,
        number: false,
        specialChar: false,
        minLength: false,
    });

    useEffect(() => {
        if (!UserProfileID) {
            navigate("/");
        }
    }, [UserProfileID]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));

        setValidation({
            lowercase: /[a-z]/.test(value),
            uppercase: /[A-Z]/.test(value),
            number: /\d/.test(value),
            specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(value),
            minLength: value.length >= 8,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage("");
        setErrorMessage("");
        if (!validateForm()) return;

        const data = {
            ...formData,
            userId: UserProfileID?._id
        };
        const response = await HttpClient.requestData("change-password", "PUT", data);
        if (response && response?.status) {
            toast.success("Password updated successfully!!.");
            setFormData({
                currentPassword: "",
                password: "",
                confirmPassword: "",
            });
        } else {
            // setErrors(response?.error);
            setErrorMessage(response?.message);
        }
    };

    const validateForm = () => {
        const newErrors = {};

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,16}$/;
        if (formData.currentPassword.trim() === "") {
            newErrors.currentPassword = "Current password is required";
        } else if (!passwordRegex.test(formData.currentPassword)) {
            newErrors.currentPassword = "Password must be 8-16 characters long, include at least one uppercase letter, one lowercase letter, one digit, and one special character.";
        }

        if (formData.password.trim() === "") {
            newErrors.password = "New password is required";
        } else if (!passwordRegex.test(formData.password)) {
            newErrors.password = "Password must be 8-16 characters long, include at least one uppercase letter, one lowercase letter, one digit, and one special character.";
        }

        if (formData.confirmPassword.trim() === "") {
            newErrors.confirmPassword = "Confirm password is required";
        } else if (!passwordRegex.test(formData.confirmPassword)) {
            newErrors.confirmPassword = "Password must be 8-16 characters long, include at least one uppercase letter, one lowercase letter, one digit, and one special character.";
        } else if (formData.confirmPassword !== formData.password) {
            newErrors.confirmPassword = "Password mis-match";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleCancelClick = () => {
        navigate("/profile/" + UserProfileID?.userName);
    }

    return (
        <form onSubmit={handleSubmit} className="form-mid">
            <div className="form-group  pswd-rule-div">
                <label>Current Password</label>
                <input
                    // type="password"
                    type={showPassword ? "text" : "password"}
                    name="currentPassword"
                    className={`form-control ${errors.currentPassword ? "is-invalid" : ""}`}
                    value={formData.currentPassword}
                    onChange={handleChange}
                    required
                />
                <div
                    className="show-eye-icon-1"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: "pointer" }}
                >
                    <i
                        className={`fa-regular ${showPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                    ></i>
                </div>
                {errors.currentPassword && (
                    <div className="invalid-feedback">{errors.currentPassword}</div>
                )}
            </div>

            <div className="form-group pswd-rule-div">
                <label>New Password</label>
                <input
                    // type="password"
                    type={showNewPassword ? "text" : "password"}
                    name="password"
                    className={`form-control ${errors.password ? "is-invalid" : ""}`}
                    value={formData.password}
                    onChange={handleChange}
                    required
                />
                <div
                    className="show-eye-icon-2"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    style={{ cursor: "pointer" }}
                >
                    <i
                        className={`fa-regular ${showNewPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                    ></i>
                </div>
                <PasswordRuleTemplate validation={validation} />
                
                {errors.password && (
                    <div className="invalid-feedback">{errors.password}</div>
                )}
            </div>

            <div className="form-group  pswd-rule-div">
                <label>Confirm Password</label>
                <input
                    // type="password"
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                />
                <div
                    className="show-eye-icon-3"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{ cursor: "pointer" }}
                >
                    <i
                        className={`fa-regular ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                    ></i>
                </div>
                {errors.confirmPassword && (
                    <div className="invalid-feedback">{errors.confirmPassword}</div>
                )}
            </div>
            <div className="form-group">
                {errorMessage && (
                    <div className="invalid-feedback">{errorMessage}</div>
                )}

            </div>

            <button type="submit" className="btn btn-success mt-3">
                Update Password
            </button>
            <button type="button" className="btn btn-secondary mt-3 ml-2" onClick={handleCancelClick}>
                Cancel
            </button>
        </form>
    );
};

export default ChangePassword;
